<template>
    <div class="tab-pane fade show active position-relative" id="activity">
        <transition name="vue-table-loader">
            <div class="vue-details-loader alt" v-if="uiStates.showLoading">
                <span class="fa fa-cog fa-spin fa-1x"></span>
            </div>
        </transition>
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-6">
                    <h3 class="pt-2 mb-2">Generic Entity Relations</h3>
                    <p class="text-muted max-w-para text-xs">
                        Configure and edit relations between the current product and one or more generic entities. This requires the creation
                        of entity relations, which can be done <a href="/entity-relation-types">here</a>. To learn more about relations,
                        <a href="https://jasperpim.atlassian.net/wiki/spaces/JPKB/pages/57803093/Understanding+Product+Relations">
                        click here</a>.
                    </p>
                </div>
                <div class="text-right col-md-6">
                    <button v-on:click.prevent="addRelation()" v-if="!uiStates.addEntityRelation && $parent.$parent.permissionAllowed('manage_products') && $parent.$parent.permissionAllowed('product_relations')" class="btn btn-primary">Add Relation</button>
                </div>
            </div>
            <div v-if="uiStates.addEntityRelation" id="adjust_relationship" class="pl-4 pr-4 mb-3">
                <!-- if there are no relations provide a link to the create relation type -->
                <select-item-from-api-provided-list
                    :api="genericEntityRelatedTypesEndpoint"
                    :columns="['name']"
                    list-label="1) Select Relation Type"
                    @selection="handleRelationSelected"
                >
                </select-item-from-api-provided-list>
                <select-item-from-api-provided-list
                    v-if="selectedRelationshipType.generic_entity_id != null"
                    class="pt-2"
                    :api="concreteEntitiesEndpoint"
                    :columns="['name', 'slug']"
                    list-label="2) Select Concrete Entity"
                    @selection="handleEntitySelected"
                    apiType="grid"
                    ref="selectFromApi"
                >
                </select-item-from-api-provided-list>

                <div class="apply-new-relationship">
                    <a v-on:click.prevent="postRelation()" :class="{disabled: !selectionsComplete}" href="#" class="mr-1 btn btn-primary">Add Relation</a>
                    <a v-on:click.prevent="uiStates.addEntityRelation = false" href="#" class="btn btn-secondary">Close</a>
                </div>
            </div>
            <div v-for="relation in relations" class="table_container">
                <div class="row">
                    <div class="clearfix col-md-12">
                        <h3 class="text-sm" style="color: #576670;">{{relation.name}}</h3>
                    </div>
                </div>
                <div class="dataTables_wrapper container-fluid dt-bootstrap4">
                   <table class="table table-middle table-minimal">
                           <thead>
                               <tr>
                                    <th>Name</th>
                                    <th style=""></th>
                               </tr>
                           </thead>
                           <tbody v-for="entity in relation.concreteEntities">
                               <tr class="scan-thumbnail">
                                    <td>
                                        <div class="position-relative">
                                            <a class="d-block text-xs" :href="`/concrete-entity/${entity.genericEntityId}/edit/${entity.id}`">
                                                {{entity.name}}
                                            </a>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="clearfix actions-relation-container" v-if="$parent.$parent.permissionAllowed('manage_products') && $parent.$parent.permissionAllowed('product_relations')">
                                            <div class="clearfix action-container">
                                                <transition v-bind:name="confirmDelete.transitionValue">
                                                    <div v-if="showConfirmDeleteButton(confirmDelete, entity)" class="btn-group btn-confirm-delete">
                                                        <a class="btn btn-danger"  v-on:click.prevent="deleteRelation(entity.id, entity.concreteEntityRelatedTypeId)" href=""><span>Confirm</span></a>
                                                        <div class="btn btn-outline-danger" @click="cancelDeletion()"><i class="fa fa-times" aria-hidden="true"></i></div>
                                                    </div>

                                                    <button class="btn btn-danger btn-start-confirmation" @click="confirmDeletion(entity)" v-if="showDeleteButton(confirmDelete, entity)"><span>Delete</span></button>
                                                </transition>
                                            </div>
                                        </div>
                                    </td>
                               </tr>
                           </tbody>
                       </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var base_url = window.location.protocol + "//" + window.location.host;
import axios from "axios";
import SelectItemFromApiProvidedList from "../generic/select-item-from-api-provided-list.vue";
import BasePagination from "../tables/base-pagination.vue";
import BasePaginationInfo from "../tables/base-pagination-info.vue";
import InputLoader from "../form/form-loader.vue";

export default {
    name: "product-entity-relations-list",
    components: {
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
        "input-loader": InputLoader,
        "select-item-from-api-provided-list": SelectItemFromApiProvidedList
    },
    data() {
        return {
            genericEntityRelatedTypesEndpoint: '/pimapi/concrete-entity-related-types',
            concreteEntitiesEndpoint: '',
            uiStates: {
                showLoading: true,
                addEntityRelation: false,
            },
            confirmDelete: {
                relationId: null,
                typeId: null,
                transitionValue: "slide",
                isActive: false
            },
            relations: [],
            selectedRelationshipType: {},
            selectedEntity: {}
        };
    },
    mounted() {
        this.loadAllRelations();
    },
    watch: {
        concreteEntitiesEndpoint: function(value, oldValue) {

            this.$nextTick(() => {
                this.$refs.selectFromApi.connectApi('');
            });
        },
    },
    computed: {
        selectionsComplete() {
            return (
                this.selectedRelationshipType.hasOwnProperty("id") &&
                this.selectedEntity.hasOwnProperty("id")
            );
        }
    },
    methods: {
        handleRelationSelected(item) {
            this.selectedRelationshipType = item;
            this.concreteEntityRelatedTypeId = this.selectedRelationshipType;
            this.concreteEntitiesEndpoint = this.handleConcreteEntitiesUrl();
        },
        handleConcreteEntitiesUrl() {
            if (!this.checkIfHasGenericEntityId()) {
                return '';
            }
            return 'pimapi/generic-entity-concrete-entities/' + this.selectedRelationshipType.generic_entity_id;
        },
        checkIfHasGenericEntityId() {
            if (!this.selectedRelationshipType.generic_entity_id) {
                return false;
            }
            return true;
        },
        handleEntitySelected(item) {
            this.selectedEntity = item;
        },
        // TODO: add to sidebar
        // reloadSidebarRelations() {
        //     this.$parent.$parent.$children.forEach(function(el, i) {
        //         if (el.$options._componentTag === "product-sidebar") {
        //             el.loadProductRelations();
        //         }
        //     });
        // },
        loadAllRelations() {
            axios
                .get(
                    base_url +
                        "/pimapi/product-relation-concrete-entities/" +
                        this.$parent.$parent.product.info.id
                )
                .then(
                    function(response) {
                        this.relations = response.data.relations[0];
                        this.uiStates.showLoading = false;
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        // this.alert.status = "alert-danger";
                        this.uiStates.showLoading = false;
                        // this.$parent.$parent.alert.status = "alert-danger";
                        // this.$parent.$parent.alert.message = 'An error has occurred with relations'
                    }.bind(this)
                );
        },
        postRelation: function(criteria) {
            this.uiStates.showLoading = true;

            axios
                .post(
                    base_url +
                        "/pimapi/product-relation-concrete-entities/create/" +
                        this.$parent.$parent.product.info.id +
                        "/" +
                        this.selectedEntity.id +
                        "/" +
                        this.selectedRelationshipType.id,
                    {
                        // 'criteria': criteria,
                    }
                )
                .then(
                    function(response) {
                        this.loadAllRelations();
                        this.uiStates.showLoading = false;
                        this.uiStates.addEntityRelation = false;

                        if (response.status === 201) {
                            this.$parent.$parent.alert.status = "alert-success";
                            this.$parent.$parent.alert.message =
                                "Relation successfully added";
                        } else {
                            this.$parent.$parent.alert.status = "alert-danger";
                            this.$parent.$parent.alert.message =
                                response.data.message;
                        }
                        // this.reloadSidebarRelations();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.uiStates.showLoading = false;
                        this.uiStates.addEntityRelation = false;
                        this.$parent.$parent.alert.message =
                            error.response.data.message;
                    }.bind(this)
                );
        },
        addRelation: function() {
            this.uiStates.showLoading = true;
            this.uiStates.addEntityRelation = true;
            this.uiStates.showLoading = false;
        },
        deleteRelation: function(relationId, typeId) {
            this.uiStates.showLoading = true;

            axios
                .post(
                    base_url +
                        `/pimapi/product-relation-concrete-entities/delete/${
                            this.$parent.$parent.product.info.id
                        }/${relationId}/${typeId}`,
                    {
                        // 'criteria': criteria,
                    }
                )
                .then(
                    function(response) {
                        this.loadAllRelations();
                        this.uiStates.showLoading = false;
                        this.$parent.$parent.alert.status = "alert-success";
                        this.$parent.$parent.alert.message = response.data.message;
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.uiStates.showLoading = false;
                        this.$parent.$parent.alert.status = "alert-danger";
                        this.$parent.$parent.alert.message =
                            error.response.data.message;
                    }.bind(this)
                );
        },
        showDeleteButton(confirmDelete, product) {
            if (!this.$parent.$parent.permissionAllowed('product_relations')) {
                return false;
            }
            return !(
                confirmDelete.relationId == product.id &&
                confirmDelete.typeId == product.concreteEntityRelatedTypeId
            );
        },
        showConfirmDeleteButton(confirmDelete, product) {
            return (
                confirmDelete.relationId == product.id &&
                confirmDelete.typeId == product.concreteEntityRelatedTypeId
            );
        },
        confirmDeletion(product) {
            if (this.confirmDelete.isActive == true) {
                this.cancelDeletion();
            } else {
                this.confirmDelete.isActive = true;
                this.confirmDelete.relationId = product.id;
                this.confirmDelete.typeId = product.concreteEntityRelatedTypeId;
                this.confirmDelete.transitionValue = "slide-reverse";
            }
        },
        cancelDeletion() {
            this.confirmDelete.isActive = false;
            this.confirmDelete.relationId = null;
            this.confirmDelete.typeId = null;
            this.confirmDelete.transitionValue = "slide";
        }
    }
};
</script>
<style lang="scss" scoped>
.apply-new-relationship {
    display: flex;
    justify-content: flex-end;
}

.product-details-thumbnail {
    position: absolute;
    top: -5px;
    left: 0;
    width: 45px !important;
    height: 45px !important;
}
.has-thumb {
    padding-left: 55px;
}
.table_container {
    margin-bottom: 40px;
}
.table tbody + tbody {
    border-top: 0px;
}
.btn-danger {
    padding: 10px 15px;
    &:hover,
    &:active,
    &:focus {
        color: white !important;
    }
}
.channel-tool-menu {
    display: inline;
    .btn {
        margin-top: -1px;
        width: 26px;
        height: 26px;
        padding: 0 0;
        border-color: #adadad;
        color: #686868;
    }
}
.table-minimal {
    margin-bottom: 0px !important;
    .btn {
        margin-top: 5px;
        margin-bottom: 5px;
        margin-right: 1px;
        padding: 9px 8px 8px 8px;
        font-size: 10px;
        font-weight: 500;
        line-height: 7px;
        height: 25px;
    }
}
.product-tool-menu {
    display: inline;
}
.channel-action-container {
    text-align: right;
}
.activities-table {
    min-height: 680px;
}
.channel-logo {
    width: 35px;
}
.badge-checkbox {
    text-transform: capitalize;
    border-color: #adadad;
    background-color: #fff;
    color: #686868;
    margin-top: 5px;
    width: 73px;
    .checkmark {
        border-color: #adadad;
        &:after {
            color: #3cab9f;
        }
    }
    &.badge-checkbox-checked {
        color: white;
        background-color: #3cab9f;
        border-color: #3cab9f;
        .checkmark {
            border-color: white;
        }
    }
}
.messaging {
    color: #566670;
    position: absolute;
    bottom: 2px;
    right: 5px;
    font-size: 9px;
}

.btn-confirm-delete {
    .btn {
        padding: 8px 8px 9px 8px;
        &:last-child {
            z-index: 10;
        }
    }
}
.actions-relation-container {
    .action-container {
        margin-left: 5px;
    }
    .btn,
    .action-container {
        float: right;
    }
}
.btn-outline-danger {
    border-color: #ab5755;
    color: #ab5755;
}
.btn-outline-primary {
    padding: 8px 8px 8px 8px !important;
    width: 75px;
}
.action-container {
    position: relative;
    overflow: hidden;
    height: 25px;
    width: 79px;
    background-color: #ab5755;
    border-radius: 2px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-right: 1px;
    .btn {
        margin-top: 0px;
        margin-bottom: 0px;
        margin-right: 0px;
        padding: 8px 8px 8px 8px;
    }
    .btn-start-confirmation {
        width: 100%;
    }
    .btn-confirm-delete,
    .btn-start-confirmation {
        position: absolute;
        top: 0;
    }
}
.slide-reverse-leave-active,
.slide-reverse-enter-active,
.slide-leave-active,
.slide-enter-active {
    transition: 0.4s;
}
.slide-enter {
    transform: translate(-100%, 0);
    span {
        transition: opacity 0.4s;
        opacity: 1;
    }
}
.slide-leave-to {
    span {
        transition: opacity 0.4s;
        opacity: 0;
    }
    transform: translate(100%, 0);
}

.slide-reverse-enter {
    transform: translate(100%, 0);
    span {
        transition: opacity 0.4s;
        opacity: 1;
    }
}
.slide-reverse-leave-to {
    span {
        transition: opacity 0.4s;
        opacity: 0;
    }
    transform: translate(-100%, 0);
}
</style>
